$(document).ready(function() { 
var maincontent = $('.customfooter-newsletter-wrapper-container');
let result = maincontent.slice(-1).remove();
});


$(function() {
    var header = $('body');
      $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 9400) {
           header.addClass('scrollActive');
      } else {
           header.removeClass('scrollActive');
        
        }
    });
  })


   $(document).on("click", ".anchorbutton", function(e){
  e.preventDefault();
  $('html, body').animate({
  scrollTop: $(".footer-newsletter-wrapper-container").offset().top
  }, 1000)
  
  });



// $(document).on('click','.Cross_icon',function(){
// $('.Main_Custom').addClass('Removesection');
// document.cookie = 'popup_accepted=true';
    
// });


$(document).ready(function () {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf('popup_accepted=') === 0) {

            $('.Main_Custom').addClass('Removesection');
            break; 
        }
    }
    

    $(document).on('click', '.Cross_icon', function () {
        document.cookie = 'popup_accepted=true';
        $('.Main_Custom').addClass('Removesection');
    });
});




